import { Filter } from "../../components/FilterChips/FilterChips";

import { GetEmployeeMeetingStatsParams } from "../../api/services/defs/internal-api";

import { DATE_RANGE_OPTIONS } from "./config";
import { CompanyMeetingsCoverageFilters } from "./schema";

const getDateRangeLabel = (value: string): string =>
	DATE_RANGE_OPTIONS.find((option) => option.value === value)?.label ?? value;

/**
 * Convert the applied filters into filter chips for display above the table.
 */
export const convertFiltersToFilterChips = (filters: CompanyMeetingsCoverageFilters) => {
	const filterChips: Filter[] = [];

	if (filters.employee) {
		filterChips.push({
			id: "employee",
			type: "single-employee",
			label: "Employee",
			value: { id: filters.employee.id, name: filters.employee.name },
		});
	}

	if (filters.manager) {
		filterChips.push({
			id: "manager",
			type: "single-employee",
			label: "Manager",
			value: { id: filters.manager.id, name: filters.manager.name },
		});
	}

	if (filters.group) {
		filterChips.push({
			id: "group",
			type: "string",
			label: "Group",
			value: filters.group.name,
		});
	}

	if (filters.dateRange && filters.dateRange !== "all_time") {
		filterChips.push({
			id: "dateRange",
			type: "string",
			label: "Date Range",
			value: getDateRangeLabel(filters.dateRange),
		});
	}

	if (filters.withoutMeetings) {
		filterChips.push({
			id: "withoutMeetings",
			type: "string",
			label: "Employees",
			value: "Without Meetings",
		});
	}

	return filterChips;
};

/**
 * Convert the UI filters into search-service parameters (separate from pagination/sort).
 */
export const getEmployeeMeetingStatsSearchServiceFilters = (
	filters: CompanyMeetingsCoverageFilters,
	searchValue?: string
) => {
	const finalFilters: Partial<GetEmployeeMeetingStatsParams> = {
		dateRange: filters.dateRange ?? "all_time",
	};

	if (filters.employee) {
		finalFilters.employeeId = filters.employee.id;
	}

	if (filters.manager) {
		finalFilters.managerId = filters.manager.id;
	}

	if (filters.group) {
		finalFilters.groupId = filters.group.id;
	}

	if (filters.withoutMeetings) {
		finalFilters.withoutMeetings = true;
	}

	if (searchValue) {
		finalFilters.name = searchValue;
	}

	return finalFilters;
};
